import NewsroomDetail from "@components/pages/newsroom/newsroom-detail"
import { getPostBySlug } from "lib/api"

function NewsDetailPage({ data, locale }) {
  return (
    <>
      <NewsroomDetail data={data} locale={locale} />
    </>
  )
}
export default NewsDetailPage

// export async function getStaticPaths() {
//   const routes = ["newest-cinema"]?.map((item) => ({
//     params: { slug: item },
//   }))
//   return { paths: routes, fallback: false }
// }

// export async function getStaticProps(ctx) {
//   const { slug } = ctx.params
//   return {
//     props: {
//       seo: {
//         title: "News 1",
//       },
//       page: "news-detail",
//       theme: "white",
//     },
//     revalidate: 60,
//   }
// }

export async function getServerSideProps(ctx) {
  ctx.res.setHeader(
    "Cache-Control",
    "public, s-maxage=43200, stale-while-revalidate=60"
  )
  const { locale } = ctx
  const { slug } = ctx.query
  try {
    const data = await getPostBySlug(slug)
    return {
      props: {
        seo: {
          title: data[`title_${locale}`] || "Newsroom",
        },
        page: "newsroom-detail",
        theme: "white",
        data,
        locale,
      },
    }
  } catch (error) {
    return { notFound: true }
  }
}
